export default {
  OVERDUE: "OverdueException",
  PERMISSION: "PermissionException",
  AUTHORIZATION: "UnauthorizedHttpException",
  EXPIRED_TRIAL: "TrialExpiredException",
  VALIDATION: "ValidationException",
  REDIRECT: "RedirectException",
  INTERNAL_ERROR: "General",
  MODEL_NOT_FOUND: "ModelNotFoundException",
  VerifyEmailUserException: "VerifyEmailUserException",
  INSERT_PASSWORD: "InsertPasswordException",
  USER_NOT_YET_CREATED: "UserNotYetCreatedException",
  INVALID_CREDENTIALS: "InvalidCredentialsException"
};
